import { z } from 'zod'

export const MailboxDelegationInfo = z.object({
  id: z.number(),
  domain_id: z.number(),
  domain_name: z.string(),
  mail_subdomains: z.array(z.string()).optional(),
  permissions: z.array(z.string()),
  granted_at: z.string(),
  expires_at: z.string().nullable().optional()
})

export type MailboxDelegationInfo = z.infer<typeof MailboxDelegationInfo>

export const MailboxDelegateInfo = z.object({
  id: z.number(),
  email: z.string(),
  permissions: z.array(z.string()),
  granted_at: z.string(),
  expires_at: z.string().nullable().optional()
})

export type MailboxDelegateInfo = z.infer<typeof MailboxDelegateInfo>

export const AddMailboxDelegateRequest = z.object({
  email: z.string().email(),
  permissions: z.array(z.string()).min(1),
  expires_at: z.string().nullable().optional()
})

export type AddMailboxDelegateRequest = z.infer<typeof AddMailboxDelegateRequest>

export const UpdateMailboxDelegateRequest = z.object({
  permissions: z.array(z.string()).optional(),
  expires_at: z.string().nullable().optional()
})

export type UpdateMailboxDelegateRequest = z.infer<typeof UpdateMailboxDelegateRequest>

export const MAILBOX_DELEGATION_PERMISSIONS = [
  'mailbox:read',
  'mailbox:write',
  'mailbox:delete',
  'mailinglist:read',
  'mailinglist:write',
  'alias:read',
  'alias:write',
  'alias:delete'
] as const
